import { motion } from 'framer-motion';
import { Button } from '../../ui/button';
import { BookOpen, X } from '@phosphor-icons/react';
import { hormoneEducation } from '../constants/hormoneData';

export const HormoneEducationModal = ({ hormoneKey, onClose }) => {
  const hormone = hormoneEducation[hormoneKey];
  
  if (!hormone) return null;
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-2xl p-6 sm:p-8 max-w-lg w-full shadow-2xl max-h-[90vh] overflow-y-auto"
      >
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#7C3AED] to-[#EC4899] flex items-center justify-center">
              <BookOpen className="w-6 h-6 text-white" weight="duotone" />
            </div>
            <div>
              <h3 className="text-lg font-bold text-[#0F172A]">{hormone.name}</h3>
              <p className="text-sm text-[#64748B]">Educational Information</p>
            </div>
          </div>
          <button 
            onClick={onClose}
            className="w-8 h-8 rounded-full bg-[#F1F5F9] hover:bg-[#E2E8F0] flex items-center justify-center"
          >
            <X className="w-4 h-4 text-[#64748B]" />
          </button>
        </div>
        
        <div className="space-y-4">
          <div>
            <h4 className="font-semibold text-[#334155] mb-1">What is it?</h4>
            <p className="text-sm text-[#64748B]">{hormone.description}</p>
          </div>
          
          <div className="bg-[#F5F3FF] rounded-xl p-4 border border-[#DDD6FE]">
            <h4 className="font-semibold text-[#5B21B6] mb-1">Why it matters for menopause</h4>
            <p className="text-sm text-[#7C3AED]">{hormone.significance}</p>
          </div>
          
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-[#F0FDF4] rounded-lg p-3 border border-[#BBF7D0]">
              <p className="text-xs text-[#166534] font-medium">Normal Range</p>
              <p className="text-sm text-[#166534]">{hormone.normalRange}</p>
            </div>
            <div className="bg-[#FEF3C7] rounded-lg p-3 border border-[#FDE68A]">
              <p className="text-xs text-[#92400E] font-medium">Testing Tip</p>
              <p className="text-sm text-[#92400E]">{hormone.tips}</p>
            </div>
          </div>
        </div>
        
        <Button 
          onClick={onClose} 
          className="w-full mt-6 bg-gradient-to-r from-[#7C3AED] to-[#EC4899] hover:opacity-90 rounded-xl h-11"
        >
          Got it
        </Button>
      </motion.div>
    </div>
  );
};
